import Box from "@mui/material/Box";
import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DriverView from "@/components/DriverView";
import ChannelsTable from "@/components/MiddleTableNavigation/ChannelsTable.tsx";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider";

export default function MiddleColumn() {
  const { workspaceId, subPage, type, workspaceMembershipId } = useParams();
  const { workspaces } = useContext(WorkspaceContext);
  const navigate = useNavigate();
  const subPageOrType = subPage || type || (workspaceMembershipId ? "drivers" : undefined);

  useEffect(() => {
    if (subPageOrType === "feeds") {
      navigate(`/workspaces/${workspaceId}/drivers`);
    }
  }, [subPageOrType]);

  useEffect(() => {
    const workspace = workspaces?.find((ws) => ws.id === workspaceId);
    const base = workspace ? `Storyboard | ${workspace.name}` : "Storyboard";
    const stripped = document.title.match(/^\(\d+\)\s*/)?.[0] ?? "";
    document.title = `${stripped}${base}`;
  }, [workspaceId, workspaces]);

  return (
    <Box sx={{ height: "100vh", bgcolor: "var(--color-zinc-900)", position: "relative", zIndex: 20 }}>
      {subPageOrType === "drivers" && <DriverView />}
      {subPageOrType === "channels" && <ChannelsTable />}
    </Box>
  );
}
